











































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import wordpressSuiteModule from "@/store/modules/wordpress-suite-module";
import { WpProductoDto } from "@/shared/dtos/wordpress/wp-producto.dto";
import { WpPedidoDto } from "@/shared/dtos/wordpress/wp-pedido.dto";

@Component({})
export default class WordpressSuite extends Vue {
    tab: string = "productos";

    busquedaProducto: string = "";
    statusProducto: string = "any";
    paginaProducto: number = 1;
    perPageProducto: number = 20;
    cargandoProductos: boolean = false;

    statusPedido: string = "any";
    paginaPedido: number = 1;
    perPagePedido: number = 20;
    cargandoPedidos: boolean = false;

    dialogEliminar: boolean = false;
    productoAEliminar: WpProductoDto | null = null;
    eliminando: boolean = false;

    dialogDetalle: boolean = false;
    pedidoDetalle: WpPedidoDto | null = null;

    dialogEstado: boolean = false;
    pedidoEstado: WpPedidoDto | null = null;
    nuevoEstado: string = "";
    guardandoEstado: boolean = false;

    dialogSeo: boolean = false;
    productoSeo: WpProductoDto | null = null;
    seoLoading: boolean = false;
    seoGuardando: boolean = false;
    seoResultado: { titulo_seo: string; descripcion_seo: string; short_description: string; meta_keywords: string } | null = null;

    get productos(): WpProductoDto[] { return wordpressSuiteModule.productos; }
    get pedidos(): WpPedidoDto[] { return wordpressSuiteModule.pedidos; }
    get totalProductos(): number { return wordpressSuiteModule.totalProductos; }
    get totalPedidos(): number { return wordpressSuiteModule.totalPedidos; }
    get totalPaginasProducto(): number { return Math.ceil(this.totalProductos / this.perPageProducto); }
    get totalPaginasPedido(): number { return Math.ceil(this.totalPedidos / this.perPagePedido); }

    async created() {
        await this.buscarProductos();
    }

    async buscarProductos() {
        this.paginaProducto = 1;
        await this.cargarProductos();
    }

    async cargarProductos() {
        this.cargandoProductos = true;
        try {
            await wordpressSuiteModule.getProductos({
                page: this.paginaProducto,
                perPage: this.perPageProducto,
                search: this.busquedaProducto,
                status: this.statusProducto
            });
        } finally {
            this.cargandoProductos = false;
        }
    }

    async cargarPedidos() {
        this.cargandoPedidos = true;
        try {
            await wordpressSuiteModule.getPedidos({
                page: this.paginaPedido,
                perPage: this.perPagePedido,
                status: this.statusPedido
            });
        } finally {
            this.cargandoPedidos = false;
        }
    }

    async cambiarPaginaProducto(p: number) {
        this.paginaProducto = p;
        await this.cargarProductos();
    }

    async cambiarPaginaPedido(p: number) {
        this.paginaPedido = p;
        await this.cargarPedidos();
    }

    confirmarEliminar(p: WpProductoDto) {
        this.productoAEliminar = p;
        this.dialogEliminar = true;
    }

    async eliminarProducto() {
        if (!this.productoAEliminar) return;
        this.eliminando = true;
        try {
            await wordpressSuiteModule.eliminarProducto(this.productoAEliminar.id);
            this.dialogEliminar = false;
            this.productoAEliminar = null;
        } finally {
            this.eliminando = false;
        }
    }

    abrirDetalle(p: WpPedidoDto) {
        this.pedidoDetalle = p;
        this.dialogDetalle = true;
    }

    abrirCambioEstado(p: WpPedidoDto) {
        this.pedidoEstado = p;
        this.nuevoEstado = p.status;
        this.dialogEstado = true;
    }

    async cambiarEstadoPedido() {
        if (!this.pedidoEstado) return;
        this.guardandoEstado = true;
        try {
            await wordpressSuiteModule.actualizarEstadoPedido({ id: this.pedidoEstado.id, estado: this.nuevoEstado });
            this.pedidoEstado.status = this.nuevoEstado;
            this.dialogEstado = false;
        } finally {
            this.guardandoEstado = false;
        }
    }

    abrirSEO(p: WpProductoDto) {
        this.productoSeo = p;
        this.seoResultado = null;
        this.dialogSeo = true;
    }

    async generarSEOProducto() {
        if (!this.productoSeo) return;
        this.seoLoading = true;
        try {
            const resultado = await wordpressSuiteModule.generarSEO({
                titulo_original: this.productoSeo.name || "",
                descripcion: this.productoSeo.description || "",
                categoria: this.productoSeo.categoriaNombre || "",
                precio_amazon: parseFloat(this.productoSeo.regular_price || "0"),
                precio_venta: parseFloat(this.productoSeo.sale_price || this.productoSeo.price || this.productoSeo.regular_price || "0"),
                asin: this.productoSeo.sku || "",
            });
            this.seoResultado = resultado as any;
        } catch (e) {
            console.error("Error generando SEO:", e);
        } finally {
            this.seoLoading = false;
        }
    }

    async actualizarSEO() {
        if (!this.productoSeo || !this.seoResultado) return;
        this.seoGuardando = true;
        try {
            await wordpressSuiteModule.actualizarProductoSeo({
                id: this.productoSeo.id,
                nombre: this.seoResultado.titulo_seo,
                descripcion: this.seoResultado.descripcion_seo,
                short_description: this.seoResultado.short_description,
            });
            this.productoSeo.name = this.seoResultado.titulo_seo;
            this.dialogSeo = false;
        } finally {
            this.seoGuardando = false;
        }
    }

    formatFecha(iso: string): string {
        if (!iso) return "—";
        const d = new Date(iso);
        return d.toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" });
    }

    chipStatus(status: string): string {
        const map: Record<string, string> = { publish: "chip-green", draft: "chip-gray", trash: "chip-red", private: "chip-blue" };
        return map[status] || "chip-gray";
    }

    etiquetaStatus(status: string): string {
        const map: Record<string, string> = { publish: "Publicado", draft: "Borrador", trash: "Papelera", private: "Privado", pending: "Pendiente" };
        return map[status] || status;
    }

    chipPedido(status: string): string {
        const map: Record<string, string> = { completed: "chip-green", processing: "chip-blue", pending: "chip-yellow", "on-hold": "chip-yellow", cancelled: "chip-red", refunded: "chip-gray", failed: "chip-red" };
        return map[status] || "chip-gray";
    }

    etiquetaPedido(status: string): string {
        const map: Record<string, string> = { pending: "Pendiente", processing: "Procesando", "on-hold": "En espera", completed: "Completado", cancelled: "Cancelado", refunded: "Reembolsado", failed: "Fallido" };
        return map[status] || status;
    }
}
